export default () => {
  const storeLocators = document.querySelectorAll('#wpsl-wrap');
  if (storeLocators) {
    storeLocators.forEach(store => {
      const searchField = store.querySelector('#wpsl-search-input');
      const categorySelect = store.querySelector('#wpsl-category-list');
      const categorySelectDrowpdown = store.querySelectorAll('.wpsl-dropdown ul li');
      // const categorySelect = store.querySelector('sl-select');
      const searchButton = store.querySelector('#wpsl-search-btn');

      if (categorySelectDrowpdown) {
        categorySelectDrowpdown.forEach(element => {
          element.addEventListener('click', e => {
            let data_value = e.target.getAttribute('data-value');
            let capital = categorySelect.querySelector('option[value="' + data_value + '"]').dataset.capital;
            // fill search field with capital
            searchField.value = capital;
            // click on search button
            searchButton.click();
          })
        });
      }
    });
  }
}